import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import WorkshopsUpcomingEventsPage from './WorkshopsUpcomingEventsPage';
import WorkshopsPreviousEventsPage from './WorkshopsPreviousEventsPage';
import TrainTheTrainerPage from './TrainTheTrainerPage';
import { EventSummaryPage } from '../Common/Moodle/Event/EventSummaryPage';


export default function WorkshopsRoutes() {
  return (
    <Routes>
      <Route index element={<Navigate to="upcoming-events" replace />} />

      <Route path="upcoming-events" element={<WorkshopsUpcomingEventsPage />} />
      <Route path="previous-events" element={<WorkshopsPreviousEventsPage />} />
      <Route path="train-the-trainer" element={<TrainTheTrainerPage />} />

      {/* Event detail routes */}
      <Route
        path="upcoming-events/:courseId/:eventId"
        element={<EventSummaryPage />}
      />
      <Route
        path="previous-events/:courseId/:eventId"
        element={<EventSummaryPage />}
      />

      {/* Optional compatibility / direct deep-link route */}
      <Route
        path="event-summary/:courseId/:eventId"
        element={<EventSummaryPage />}
      />
    </Routes>
  );
}